export default __webpack_public_path__ + "static/media/Meat-2.316b0652.png";